<template>
    <Fragment>
        <Descriptions
            bordered
            :column="1"
            :title="$t('sourceItemBank')"
            layout="horizontal"
        >
            <DescriptionsItem :label="$t('language')">
                {{ measure.sourceItemBankLanguage }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('version')">
                {{ measure.sourceItemBankVersion }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('itemParametersDate')">
                {{ measure.sourceItemBankItemParametersDate | date }}
            </DescriptionsItem>
        </Descriptions>
        <Descriptions
            bordered
            :column="1"
            class="mt-4"
            :title="$t('targetItemBank')"
            layout="horizontal"
        >
            <DescriptionsItem :label="$t('language')">
                {{ measure.targetItemBankLanguage }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('code')">
                {{ measure.targetItemBankCode }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('translationDate')">
                {{ measure.targetItemBankTranslationDate | date }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('importFileDate')">
                {{ measure.targetItemBankImportFileDate | date }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('itemParametersDate')">
                {{ measure.targetItemBankItemParametersDate | date }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('testSettingsDate')">
                {{ measure.targetItemBankTestSettingsDate | date }}
            </DescriptionsItem>
        </Descriptions>
    </Fragment>
</template>

<script>
import { Descriptions } from 'ant-design-vue';
export default {
    name: 'Version',
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
    },
    props: {
        measure: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>